import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[agprTemplate]',
    standalone: false
})
export class TemplateDirective {
    @Input('agprTemplate') type: string;

    constructor(
        public template: TemplateRef<any>
    ) {}

    public getType(): string {
        return this.type;
    }
}
